
h1.modalTitle {
	@apply yst-mb-4;
}

.cancelForm {
	p {
		@apply yst-mb-4;
	}

	hr {
		@apply yst-my-4;
	}

	.listLabel {
		@apply yst-mb-2;
	}

	ul {
		@apply yst-list-disc;
		padding: revert;

		li {
			@apply yst-mb-2
			last:yst-mb-0;
		}
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type=number] {
		-moz-appearance: textfield;
	}

	.amountSelector {
		@apply yst-mb-3;
		display: flex;
		width: 100%;
		flex-wrap: wrap;

		label {
			margin-top: 1em;
			margin-bottom: 0.5em;
			width: 100%;
			flex: 2 0 auto;
			font-weight: bold;
		}

		.amountInput {
			width: 80px;
			margin: 0 8px;
			text-align: center;
			-webkit-appearance: none;
		}

		.amountButton {
			width: 40px;

			svg {
				@apply yst-text-slate-600;
				flex: 1 0 auto;
			}
		}
	}
}
